<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content is-wide">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add Slab Order Items</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <slab-item-selector 
            ref="item-selector"
            :project-id="bom.project.id"
            :exclude="bom.details.map(d => d.production_sheet_item_id)"
            @select="add($event)"
            @deselect="remove($event)"/>

        </div>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            @click.stop="addSelectedSlabItems()">
            Add Selected {{ selected.length }} Slab Items
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import SlabItemSelector from '@/components/inventory/SlabItemSelector'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { 
    SlabItemSelector
  },
  data() {
    return {
      selected: []
    }
  },
  computed: {
    ...mapState("bom", ["bom"])
  },
  methods: {
    ...mapActions("bom", ["addSlabItem"]),
    ...mapMutations("app", ["setNotification"]),
    add(slabItem) {
      this.selected.push(slabItem);
    },
    remove(slabItemId) {
      this.selected.forEach((slabItem, i) => {
        if (slabItem.id == slabItemId) {
          this.selected.splice(i, 1);
        }
      })
    },
    addSelectedSlabItems() {
      let items = this.selected.map(d => {
        return {
          bom_id: this.bom.id,
          production_sheet_item_id: d.id
        }
      });

      items.forEach((items, i) => {
        this.addSlabItem(items).then(() => {
          if (i+1 == items.length) {
            this.notifySuccess();
          }
        })
      })
    },
    notifySuccess() {
      this.setNotification({
        status: true,
        type: 'success',
        message: 'Slab Items successfully added to BOM'
      });
      
      this.close(true);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/modal.scss';

.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
